import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { ICondicaoPagamento } from '../models/condicao-pagamento';
import { CondicoesPagamentoApi } from '../api/condicoes-pagamento.api';
import { ICondicaoPagamentoDTO } from '../dto/condicao-pagamento-dto';

@Injectable()
export class CondicoesPagamentoService extends ServiceBase<ICondicaoPagamento, ICondicaoPagamentoDTO> {

    constructor(private api: CondicoesPagamentoApi) {
        super(api);
    }
}
